import { grey } from "@mui/material/colors";

const styles = {
  completeChip: {
    borderRadius: "40px",
    paddingY: 1,
    px: 2,
    fontSize: { xs: 12, md: 14 },
    fontWeight: 600,
    border: `1px solid ${grey[300]}`,
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  incompleteChip: {
    borderRadius: "40px",
    border: `1px solid ${grey[300]}`,
    paddingY: 1,
    px: 2,
    fontSize: { xs: 12, md: 14 },
    fontWeight: 600,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  circle: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "primary.main",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  timeText: {
    color: "black",
    fontSize: 14,
  },
};

export default styles;
